import faker from 'faker';
import moment from 'moment';

export default Array(10)
    .fill(0)
    .map((_, index) => {
        return({
            id: index,
            contrato: faker.random.number({min: 100, max: 500}),
            nomeFornecedor: faker.name.findName(),
            statusEncerramento: faker.lorem.word(),
            avanco: faker.random.number({min: 0, max: 100}),
            trp: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            trd: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            nadaConta: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            teqcChancelaCj: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            teqcAssinaturaFornecedor: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            teqcAssinaturaDiretoria: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            envioTeqcSuprimentos: moment(faker.date.recent(10)).format('DD/MM/YYYY')
        })
    });